import React, { useEffect, useRef, useState } from "react";
import { Image } from "react-bootstrap";
import { BsChevronDown } from "react-icons/bs";
import { IoIosClose } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import OrderPickingIcon from "../../assets/icons/OrderPicking.svg";
import plusBorderWhite from "../../assets/icons/Plus-border-white.svg";
import Downarrow from "../../assets/icons/downarrow.svg";
import Package from "../../assets/icons/package.svg";
import productIconOrder from "../../assets/icons/product-icon-order.svg";
import projectIconOrder from "../../assets/icons/productIconOrder.svg";
import quoteIconOrder from "../../assets/icons/quote-icon-order.svg";
import searchIcon from "../../assets/icons/search.svg";
import DelIcon from "../../assets/icons/DeleteIconCircle.svg";
import ShoppingCartIcon from "../../assets/icons/shopping-cart.svg";
import Header from "../../layouts/Header";
import {
  CreateOrderPicking,
  ProductProjectDropdown,
  ProjectDropdown,
  FetchPOByProject,
} from "../../redux/actions/action";
import "../../assets/styles/local/OrderPicking.css";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import useScreenSize from "../../utils/hooks/useScreenSizeHook";
import { CREATE_ORDER_PICKING } from "../../redux/constants/type";
import RouteLeavingGuard from "../../components/Common/RouteLeavingGuard";
import CancelWarningModal from "../../components/Dailogs/CancelWarningModal";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import AddPurchaseOrderDocument from "./AddPurchaseOrderDocument";

const OrderPicking = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const projectDropRef = useRef(null);
  const purchaseOrderDropRef = useRef(null);
  const productDropRef = useRef(null);
  const quoteDropRef = useRef(null);

  const fetchProjectDropdownData = useSelector(
    (state) => state.user.fetchProjectDropdown,
  );
  const fetchProductDropdownData = useSelector(
    (state) => state.user.fetchProductDropdown,
  );
  const fetchCreateOrderPicking = useSelector(
    (state) => state.user.createOrderPicking,
  );
  const fetchPOByProjectResponse = useSelector(
    (state) => state.user.fetchPOByProjectResponse,
  );
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";

  const [single, setSingle] = useState(true);
  const [list, setList] = useState(false);
  const [typeField, setTypeField] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [query, setQuery] = useState("");
  const [showClientDrop, setShowClientDrop] = useState(false);
  const [showPurchaseOrderDrop, setShowPurchaseOrderDrop] = useState(false);
  const [showProductDrop, setShowProductDrop] = useState(false);
  const [showQuoteDrop, setShowQuoteDrop] = useState(false);
  const [projectId, setProjectId] = useState("");

  const [projectTableData, setProjectTableData] = useState([]);
  const [selectedProject, setsSelectedProject] = useState(null);
  const [projectSearch, setProjectSearch] = useState("");

  const [purchaseOrderData, setPurchaseOrderData] = useState([]);
  const [selectedPurchaseOrder, setSelectedPurchaseOrder] = useState(null);
  const [purchaseOrderId, setPurchaseOrderId] = useState(null);
  const [purchaseSupplierId, setPurchaseSupplierId] = useState(null);
  const [purchaseOrderSearch, setPurchaseOrderSearch] = useState("");

  const [productTableData, setProductTableData] = useState([]);
  const [productBottomTableData, setProductBottomTableData] = useState({});
  const [selectedProduct, setsSelectedProduct] = useState(null);
  const [searchItems, setSearchItems] = useState("");
  const [productId, setProductId] = useState("");
  const [showProductBottomList, setShowProductBottomList] = useState(false);
  const myAppName = localStorage.getItem("myAppName");
  const isOrderPicking = myAppName === "orderpicking";

  const [selectedQuote, setsSelectedQuote] = useState(null);
  const [coverImage, setCoverImage] = useState("");
  const [isBuildingBlock, setIsBuildingBlock] = useState(false);
  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions,
  );
  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      setIsBuildingBlock(
        getAppSideNavOptions.some(
          (x) => x.packageId === process.env.REACT_APP_IS_PREMIUM,
        ),
      );
    }
  }, [getAppSideNavOptions]);

  const [showOrderNotification, setShowOrderNotification] = useState(false);

  useEffect(() => {
    dispatch(ProjectDropdown());
    fetchScreenTranslations("Order Picking").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  useEffect(() => {
    if (projectId) {
      // dispatch(ProductProjectDropdown(projectId));
    }
  }, [dispatch, projectId]);

  useEffect(() => {
    if (fetchProjectDropdownData != null) {
      if (fetchProjectDropdownData?.status) {
        setProjectTableData(fetchProjectDropdownData?.data);
      }
    }
  }, [fetchProjectDropdownData]);

  useEffect(() => {
    if (fetchPOByProjectResponse != null) {
      if (fetchPOByProjectResponse?.status) {
        setPurchaseOrderData(fetchPOByProjectResponse?.data);
      }
    }
  }, [fetchPOByProjectResponse]);

  useEffect(() => {
    if (fetchProductDropdownData != null) {
      if (fetchProductDropdownData?.status) {
        setProductTableData(fetchProductDropdownData?.data);
      }
    }
  }, [fetchProductDropdownData]);

  useEffect(() => {
    if (fetchCreateOrderPicking != null) {
      if (fetchCreateOrderPicking?.status) {
        setsSelectedProject(null);
        setProjectId("");
        setsSelectedProduct(null);
        setsSelectedQuote(null);
        setShowOrderNotification(true);
        setShowProductBottomList(false);
        dispatch({
          type: CREATE_ORDER_PICKING,
          data: {},
        });
        setCoverImage("");
        setProductTableData([]);
        setProjectSearch("");
        setPurchaseOrderSearch("");
        setSelectedPurchaseOrder(null);
        setProductBottomTableData({});
        setProductId("");
        if (screenSize !== "xs" && !isOrderPicking) {
          handleGeneralNotification({
            notificationType: "CUSTOM",
            text: `Great Job! The product was picked for the project.`,
          });
        }
      }
    }
  }, [fetchCreateOrderPicking]);

  useEffect(() => {
    if (projectSearch) {
      let list = [...fetchProjectDropdownData?.data];
      list = list.filter((client) => {
        return (
          client?.projectname
            ?.toLowerCase()
            ?.startsWith(projectSearch.toLowerCase()) ||
          client?.projectcode
            ?.toLowerCase()
            ?.startsWith(projectSearch.toLowerCase())
        );
      });
      setProjectTableData(list);
    } else {
      setProjectTableData(fetchProjectDropdownData?.data);
    }
  }, [projectSearch]);

  useEffect(() => {
    if (purchaseOrderSearch) {
      let list = [...fetchPOByProjectResponse?.data];
      list = list.filter((poItem) => {
        return (
          poItem?.suppliername
            ?.toLowerCase()
            ?.startsWith(purchaseOrderSearch.toLowerCase()) ||
          poItem?.ordercode
            ?.toLowerCase()
            ?.startsWith(purchaseOrderSearch.toLowerCase())
        );
      });
      setPurchaseOrderData(list);
    } else {
      setPurchaseOrderData(fetchPOByProjectResponse?.data);
    }
  }, [purchaseOrderSearch]);

  useEffect(() => {
    if (searchItems) {
      if (fetchProductDropdownData != null) {
        if (fetchProductDropdownData?.status) {
          const originalData = fetchProductDropdownData?.data || [];

          const dataToSet = originalData?.filter(
            (name) =>
              name.productPartName ||
              "".toLowerCase().includes(searchItems.toLowerCase()) ||
              name.productPartCode
                .toLowerCase()
                .includes(searchItems.toLowerCase()) ||
              name.productPartDescription
                .toLowerCase()
                .includes(searchItems.toLowerCase()) ||
              // supplier name and item id searching
              name.productpartsupplier?.some(
                (supplier) =>
                  supplier.suppliername
                    ?.toLowerCase()
                    .includes(searchItems.toLowerCase()) ||
                  supplier.itemid
                    ?.toLowerCase()
                    .includes(searchItems.toLowerCase()),
              ),
          );
          setProductTableData(dataToSet);
        }
      }
    } else {
      setProductTableData(fetchProductDropdownData?.data);
    }
  }, [searchItems, fetchProductDropdownData]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      projectDropRef.current &&
      !projectDropRef.current.contains(event.target)
    ) {
      setShowClientDrop(false);
    }
    if (
      purchaseOrderDropRef.current &&
      !purchaseOrderDropRef.current.contains(event.target)
    ) {
      setShowPurchaseOrderDrop(false);
    }
    if (
      productDropRef.current &&
      !productDropRef.current.contains(event.target)
    ) {
      setShowProductDrop(false);
    }
    if (quoteDropRef.current && !quoteDropRef.current.contains(event.target)) {
      setShowQuoteDrop(false);
    }
  };

  const handleSelectedProduct = (items) => {
    const updatedData = {
      ...items,
      qtyToPick: items.qtyToPick,
      newQtyToPick: items.qtyToPick,
    };
    setProductBottomTableData(updatedData);
    setsSelectedProduct(items.productPartName);
    setShowProductDrop(false);
    setProductId(items.productPartid);
    setShowProductBottomList(true);
    setCoverImage(items.cover);
  };

  const handleInputChange = (e) => {
    e.preventDefault();
    const { value } = e.target;
    const newValue = Number(value);
    setProductBottomTableData({
      ...productBottomTableData,
      newQtyToPick: newValue,
    });
  };

  const HandleAddPickingOrder = () => {
    if (
      productBottomTableData?.newQtyToPick > productBottomTableData?.instock ||
      productBottomTableData?.newQtyToPick >
        productBottomTableData?.qtyToPick ||
      productBottomTableData?.qtyToPick === 0 ||
      productBottomTableData?.newQtyToPick === 0 ||
      productBottomTableData?.instock === 0
    ) {
      if (screenSize !== "xs" && !isOrderPicking) {
        handleGeneralNotification({
          notificationType: "CUSTOM",
          text: `please adjust qty to pick according to a stock.`,
        });
      }
      return;
    }
    setTypeField("");
    const orderProductQty = [
      {
        orderproductqty: productBottomTableData.newQtyToPick,
      },
    ];
    dispatch(
      CreateOrderPicking(
        "",
        productId,
        projectId,
        purchaseOrderId,
        orderProductQty,
      ),
    );
  };

  const screenSize = useScreenSize();

  const handleClose = () => setModalShow(false);
  const handleCancel = () => {
    history.goBack();
  };

  return (
    <>
      <Header
        setQuery={setQuery}
        leftComponent={
          <div className="products-and-parts-header-content">
            <div
              className="products-and-parts-main-title  cursor-pointer"
              onClick={() => {
                history.push("/stock");
              }}
            >
              {/* Stock */}
              {t("Stock")}
            </div>
            <p className="products-and-parts-sub-title">
              {/* Order Picking */}
              {t("Order Picking")}
            </p>

            <div className="d-flex mainSwitch ms-5 pointer">
              <div
                className={
                  single ? "singleSwitch px-4 py-1" : "noSwitch px-4 py-1"
                }
                onClick={() => {
                  setSingle(true);
                  setList(false);
                  history.push("/order-picking");
                }}
              >
                {/* Single */}
                {t("Single")}
              </div>
              <div
                className={list ? "listSwitch px-4 py-1" : "noSwitch px-4 py-1"}
                onClick={() => {
                  setList(true);
                  setSingle(false);
                  history.push("/OrderPickingList");
                }}
              >
                {/* List */}
                {t("List")}
              </div>
            </div>
          </div>
        }
      />
      {modalShow && (
        <CancelWarningModal
          show={modalShow}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          handleCancel={handleCancel}
        />
      )}
      <RouteLeavingGuard
        when={typeField !== ""}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={(location) => {
          if (typeField !== "") {
            if (!["/stock"].includes(location.pathname)) {
              return true;
            }
          }
          return false;
        }}
      />
      <div className="container-fluid">
        <div className="main-wrapper1 mb-4">
          <div>
            {(screenSize === "xs" || isOrderPicking) && (
              <div
                style={{
                  display: "flex",
                  // gap: "10px",
                  // justifyContent: "space-between",
                }}
              >
                <div
                  style={{ display: "flex", gap: "1px" }}
                  onClick={() => {
                    history.push("/stock");
                  }}
                >
                  <div
                    style={{
                      color: "#7F7E7F",
                      fontWeight: "bolder",
                      fontSize: "1.1rem",
                      marginTop: "10px",
                      marginBottom: "15px",
                      paddingLeft: "20px",
                    }}
                  >
                    {/* Stock */}
                    {t("Stock")}
                  </div>
                  <img
                    alt=""
                    src={Downarrow}
                    style={{
                      opacity: "60%",
                      marginTop: "18px",
                      marginBottom: "15px",
                      width: "15px",
                      height: "12px",
                      transform: "rotate(90deg)",
                      cursor: "pointer",
                    }}
                  />
                </div>
                <div
                  style={{ display: "flex", gap: "4px", marginRight: "20px" }}
                >
                  <img
                    alt=""
                    src={OrderPickingIcon}
                    style={{
                      opacity: "60%",
                      marginTop: "12px",
                      marginBottom: "15px",
                      width: "15px",
                      height: "24px",
                      transform: "rotate(0deg)",
                      cursor: "pointer",
                    }}
                  />
                  <div
                    style={{
                      color: "#7F7E7F",
                      fontWeight: "bolder",
                      fontSize: "1rem",
                      marginTop: "11px",
                      marginBottom: "15px",
                    }}
                  >
                    {/* Order Picking */}
                    {t("Order Picking")}
                  </div>
                </div>
              </div>
            )}
            <div className="order-picking-header">
              {screenSize !== "xs" && !isOrderPicking && (
                <div className="OrderPicking-action d-flex justify-content-end mb-4">
                  <div className="ps-2 me-3" style={{ paddingTop: "0px" }}>
                    <AddPurchaseOrderDocument
                      // poOrderCode={poOrderCode}
                      orderid={purchaseOrderId}
                      isDisabled={true}
                      style={{ height: "42px", borderRadius: "12px" }}
                    />
                  </div>

                  <button
                    className="cancel-btn"
                    onClick={() => {
                      if (typeField !== "") {
                        setModalShow(true);
                      } else {
                        history.goBack();
                      }
                    }}
                  >
                    {/* Cancel */}
                    {t("Cancel")}
                  </button>

                  <button
                    style={{
                      cursor:
                        productId === "" ||
                        productBottomTableData?.ispicked === 1
                          ? "not-allowed"
                          : "pointer",
                      pointerEvents: "visible",
                    }}
                    disabled={
                      productId === "" ||
                      projectId === "" ||
                      productBottomTableData?.ispicked === 1
                    }
                    className="add-btn ms-3"
                    onClick={HandleAddPickingOrder}
                  >
                    {/* Add */}
                    {t("Add")}
                  </button>
                </div>
              )}
            </div>

            <div
              className={`${
                screenSize === "xs" || isOrderPicking
                  ? "order-picking-content-mobile"
                  : "order-picking-content pb-0"
              }`}
              style={{ minHeight: "auto" }}
            >
              <div className="row">
                <div className="p-0 col-xl-6">
                  <div
                    className="list-Of-Field"
                    style={{
                      position: "relative",
                      marginBottom:
                        screenSize === "xs" || isOrderPicking ? "0px" : "50px",
                    }}
                    ref={projectDropRef}
                  >
                    {screenSize !== "xs" && !isOrderPicking && (
                      <div className="project-lable d-flex mb-3">
                        <img
                          alt=""
                          src={projectIconOrder}
                          className="project-form-icon"
                        />
                        <h5 className="project-lable-heading">
                          {/* Project */}
                          {t("Project")}
                        </h5>
                      </div>
                    )}
                    {screenSize === "xs" || isOrderPicking ? (
                      <div>
                        <div className="project-search-main-mobile">
                          <img
                            alt=""
                            className="search_pop ms-2 mb-1"
                            src={searchIcon}
                          />
                          <input
                            type="text"
                            value={searchItems}
                            style={{
                              margin: "0 0 0 0.5rem",
                              fontSie: "14px",
                            }}
                            // placeholder="Search"
                            placeholder={t("Search ")}
                            className="search-style select-client-div"
                            onChange={(e) => {
                              setSearchItems(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="choose-project-dropdown">
                        <div
                          onClick={() => setShowClientDrop(!showClientDrop)}
                          className="project-drop-view d-flex"
                          style={{
                            justifyContent:
                              screenSize === "xs" || isOrderPicking
                                ? "flex-start"
                                : "space-between",
                          }}
                        >
                          <p className="margin-0-pop ordertype ps-2">
                            {/* {selectedProject || "Type a project "} */}
                            {selectedProject || t("Type a project")}
                          </p>

                          <BsChevronDown
                            size={18}
                            className={
                              "down-arrow-pop bi-paperclip ms-4 ms-xxl-3"
                            }
                          />
                        </div>

                        {showClientDrop && (
                          <div className="Outer-project-dropdown ps-0 pe-2">
                            <div className="project-drop d-flex justify-content-between">
                              <p className="mb-2 ps-3">
                                {/* Choose a Project */}
                                {t("Choose a Project")}
                              </p>
                              <BsChevronDown
                                size={18}
                                onClick={() =>
                                  setShowClientDrop(!showClientDrop)
                                }
                                className={"down-arrow-pop down-arrow-rotate"}
                              />
                            </div>

                            <div
                              className="project-search-main ms-2"
                              style={{ marginBottom: "10px" }}
                            >
                              <img
                                alt=""
                                className="search_pop ms-2 mb-1"
                                src={searchIcon}
                              />
                              <input
                                type="text"
                                value={projectSearch}
                                style={{
                                  margin: "0 0 0 0.5rem",
                                  fontSie: "14px",
                                }}
                                placeholder={t("Search ")}
                                className="search-style select-client-div"
                                onChange={(e) => {
                                  setProjectSearch(e.target.value);
                                }}
                              />
                            </div>
                            <div className="my-custom-scrollbar">
                              {projectTableData?.map((project) => {
                                return (
                                  <p
                                    key={project.projectid}
                                    className="mb-0 ps-2 text-for-projects ulterDrop"
                                    style={{
                                      textTransform: "capitalize",
                                      backgroundColor:
                                        selectedProject === project.projectname
                                          ? "#F4F5F4"
                                          : "transparent",
                                    }}
                                    onClick={() => {
                                      setsSelectedProject(project.projectname);
                                      setProjectId(project.projectid);
                                      setShowClientDrop(false);
                                      setTypeField("asc");
                                      setsSelectedProduct(null);
                                      setsSelectedQuote(null);
                                      setShowProductBottomList(false);
                                      dispatch({
                                        type: CREATE_ORDER_PICKING,
                                        data: {},
                                      });
                                      dispatch(
                                        FetchPOByProject(
                                          project.projectid,
                                          "Purchasing",
                                          // pageNumber,
                                          // itemsPerPage,
                                        ),
                                      );
                                      setCoverImage("");
                                      setProductTableData([]);
                                      setProductBottomTableData({});
                                      setProductId("");
                                    }}
                                  >
                                    {project?.projectcode}&nbsp;┃&nbsp;
                                    {project.projectname}
                                  </p>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  {isBuildingBlock &&
                    screenSize !== "xs" &&
                    !isOrderPicking && (
                      <div className="list-Of-Field order-pickingimagehide mb-3">
                        <div className="project-lable d-flex mb-3">
                          <h5 className="project-lable-heading">
                            {/* Product Image */}
                            {FetchTranslationList[29]?.translation}
                          </h5>
                        </div>
                        <div className="product-order-images w-100">
                          {coverImage && (
                            <img src={coverImage} alt="" className="p-2" />
                          )}
                        </div>
                      </div>
                    )}
                </div>

                {/* quote */}
                <div className="pe-0 col-xl-6">
                  <div
                    className="list-Of-Field d-none"
                    style={{ position: "relative" }}
                    ref={quoteDropRef}
                  >
                    <div className="project-lable d-flex mb-3">
                      <img
                        src={quoteIconOrder}
                        className="project-form-icon"
                        alt=""
                      />
                      <h5 className="project-lable-heading">
                        {/* Quote */}
                        {FetchTranslationList[15]?.translation}
                      </h5>
                    </div>
                    <div className="choose-project-dropdown pointerEvent">
                      <div
                        onClick={() => setShowQuoteDrop(!showQuoteDrop)}
                        className="project-drop-view d-flex justify-content-between"
                      >
                        <p className="margin-0-pop ordertype ps-2">
                          {/* {selectedQuote || "Choose a quote"} */}
                          {selectedQuote ||
                            FetchTranslationList[16]?.translation}
                        </p>
                        <BsChevronDown
                          size={18}
                          className={
                            "down-arrow-pop bi-paperclip ms-4 ms-xxl-3"
                          }
                        />
                      </div>

                      {showQuoteDrop && (
                        <div className="Outer-project-dropdown ps-0 pe-2">
                          <div className="project-drop d-flex justify-content-between">
                            <p className="mb-2">
                              {/* Select Quote */}
                              {FetchTranslationList[55]?.translation}
                            </p>
                            <BsChevronDown
                              size={18}
                              onClick={() => setShowQuoteDrop(!showQuoteDrop)}
                              className={"down-arrow-pop down-arrow-rotate"}
                            />
                          </div>
                          <div className="my-custom-scrollbar">
                            <p
                              className="mb-1 text-for-projects"
                              style={{
                                textTransform: "capitalize",
                                backgroundColor:
                                  selectedQuote === "22-00899-5"
                                    ? "#F4F5F4"
                                    : "transparent",
                              }}
                              onClick={() => {
                                setsSelectedQuote("22-00899-5");
                                setShowQuoteDrop(false);
                                setTypeField("asc");
                              }}
                            >
                              22-00899-5
                            </p>
                            <p
                              className="mb-1 text-for-projects"
                              style={{
                                textTransform: "capitalize",
                                backgroundColor:
                                  selectedQuote === "22-00899-4"
                                    ? "#F4F5F4"
                                    : "transparent",
                              }}
                              onClick={() => {
                                setsSelectedQuote("22-00899-4");
                                setShowQuoteDrop(false);
                                setTypeField("asc");
                              }}
                            >
                              22-00899-4
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* purchase order start */}
                  <div
                    className="list-Of-Field"
                    style={{
                      position: "relative",
                      marginBottom:
                        screenSize === "xs" || isOrderPicking ? "30px" : "50px",
                    }}
                    ref={purchaseOrderDropRef}
                  >
                    {screenSize !== "xs" && !isOrderPicking && (
                      <div className="project-lable d-flex mb-3">
                        <img
                          alt=""
                          src={ShoppingCartIcon}
                          className="project-form-icon"
                          style={{ opacity: "70%" }}
                        />
                        <h5 className="project-lable-heading">
                          Purchase Order
                          {/* {FetchTranslationList[11]?.translation} */}
                        </h5>
                      </div>
                    )}
                    {screenSize === "xs" || isOrderPicking ? (
                      <div>
                        <div className="project-search-main-mobile d-none">
                          <img
                            alt=""
                            className="search_pop ms-2 mb-1"
                            src={searchIcon}
                          />
                          <input
                            type="text"
                            value={searchItems}
                            style={{
                              margin: "0 0 0 0.5rem",
                              fontSie: "14px",
                            }}
                            // placeholder="Search"
                            placeholder={FetchTranslationList[24]?.translation}
                            className="search-style select-client-div"
                            onChange={(e) => {
                              setSearchItems(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="choose-project-dropdown">
                        <div
                          onClick={() =>
                            setShowPurchaseOrderDrop(!showPurchaseOrderDrop)
                          }
                          className="project-drop-view d-flex"
                          style={{
                            justifyContent:
                              screenSize === "xs" || isOrderPicking
                                ? "flex-start"
                                : "space-between",
                          }}
                        >
                          <p className="margin-0-pop ordertype ps-2">
                            {selectedPurchaseOrder || "Type a purchase order "}
                            {/* {selectedProject ||
                              FetchTranslationList[12]?.translation} */}
                          </p>

                          <BsChevronDown
                            size={18}
                            className={
                              "down-arrow-pop bi-paperclip ms-4 ms-xxl-3"
                            }
                          />
                        </div>

                        {showPurchaseOrderDrop && (
                          <div className="Outer-project-dropdown ps-0 pe-2">
                            <div className="project-drop d-flex justify-content-between">
                              <p className="mb-2 ps-3">
                                Choose a Purchase Order
                                {/* {FetchTranslationList[65]?.translation} */}
                              </p>
                              <BsChevronDown
                                size={18}
                                onClick={() =>
                                  setShowPurchaseOrderDrop(
                                    !showPurchaseOrderDrop,
                                  )
                                }
                                className={"down-arrow-pop down-arrow-rotate"}
                              />
                            </div>

                            <div
                              className="project-search-main ms-2"
                              style={{ marginBottom: "10px" }}
                            >
                              <img
                                alt=""
                                className="search_pop ms-2 mb-1"
                                src={searchIcon}
                              />
                              <input
                                type="text"
                                value={purchaseOrderSearch}
                                style={{
                                  margin: "0 0 0 0.5rem",
                                  fontSie: "14px",
                                }}
                                placeholder={t("Search ")}
                                className="search-style select-client-div"
                                onChange={(e) => {
                                  setPurchaseOrderSearch(e.target.value);
                                }}
                              />
                            </div>
                            <div className="my-custom-scrollbar">
                              {purchaseOrderData?.map((poItem) => {
                                return (
                                  <p
                                    key={poItem.projectid}
                                    className="mb-0 ps-2 text-for-projects ulterDrop"
                                    style={{
                                      textTransform: "capitalize",
                                      backgroundColor:
                                        purchaseOrderId === poItem.orderid
                                          ? "#F4F5F4"
                                          : "transparent",
                                    }}
                                    onClick={() => {
                                      setSelectedPurchaseOrder(
                                        poItem.suppliername,
                                      );
                                      setPurchaseOrderId(poItem.orderid);
                                      setPurchaseSupplierId(poItem.supplierid);
                                      setShowPurchaseOrderDrop(false);
                                      setTypeField("asc");
                                      dispatch(
                                        ProductProjectDropdown(
                                          null,
                                          poItem.orderid,
                                        ),
                                      );
                                      // setsSelectedProduct(null);
                                      // setsSelectedQuote(null);
                                      // setShowProductBottomList(false);
                                      // dispatch({
                                      //   type: CREATE_ORDER_PICKING,
                                      //   data: {},
                                      // });
                                      // setCoverImage("");
                                      // setProductTableData([]);
                                      // setProductBottomTableData({});
                                      // setProductId("");
                                    }}
                                  >
                                    {poItem?.ordercode}&nbsp;┃&nbsp;
                                    {poItem.suppliername}
                                  </p>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  {/* purchase order end */}

                  <div
                    className="list-Of-Field"
                    style={{ position: "relative" }}
                    ref={productDropRef}
                  >
                    {screenSize === "xs" || isOrderPicking ? (
                      <div className="project-lable d-flex mb-3">
                        <h5
                          className="project-lable-heading ms-0"
                          style={{ color: "#323232" }}
                        >
                          Choose From Project List
                          {/* {FetchTranslationList[14]?.translation} */}
                        </h5>
                      </div>
                    ) : (
                      <div className="project-lable d-flex mb-3">
                        <img
                          alt=""
                          src={productIconOrder}
                          className="project-form-icon"
                        />
                        <h5 className="project-lable-heading">
                          {/* Product */}
                          {t("Item Name")}
                        </h5>
                      </div>
                    )}
                    {screenSize !== "xs" && !isOrderPicking && (
                      <div
                        className={
                          screenSize === "xs" || isOrderPicking
                            ? "choose-project-dropdown-mobile"
                            : "choose-project-dropdown"
                        }
                      >
                        <div
                          className={
                            screenSize === "xs" || isOrderPicking
                              ? "project-drop-view-mobile d-flex justify-content-between"
                              : "project-drop-view d-flex justify-content-between"
                          }
                        >
                          {screenSize !== "xs" && !isOrderPicking && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                              }}
                              onClick={() =>
                                setShowProductDrop(!showProductDrop)
                              }
                            >
                              <p className="margin-0-pop ordertype ps-2">
                                {/* {selectedProduct || "Type or scan an item"} */}
                                {selectedProduct || t("Type or scan an item")}
                              </p>
                              <BsChevronDown
                                size={18}
                                className={
                                  "down-arrow-pop bi-paperclip ms-4 ms-xxl-3"
                                }
                              />
                            </div>
                          )}
                        </div>

                        {showProductDrop && (
                          <div className="add-item-wrapper order-picking-wrapper">
                            <div className="d-flex justify-content-between align-items-center bgdiv">
                              <p className="inputparts px-3">Parts</p>
                              <div className="add-item-title w-100">
                                <input
                                  className="update-member-input-noborder add-member-input bgforinput w-100"
                                  value={searchItems}
                                  onChange={(e) => {
                                    setSearchItems(e.target.value);
                                  }}
                                  placeholder={t("Search ")}
                                />
                              </div>
                              <img
                                src={DelIcon}
                                alt=""
                                className="mx-3 cursor-pointer"
                                onClick={() =>
                                  setShowProductDrop(!showProductDrop)
                                }
                              />
                            </div>
                            <div className="border-line d-none"></div>
                            <div className="stock-order-items-main gap-0 p-3">
                              {productTableData?.map((items, index) => (
                                <div key={index} className="w-100">
                                  <div
                                    className="missing-order-items add-item-title"
                                    onClick={() => {
                                      handleSelectedProduct(items);
                                      setShowProductDrop(!showProductDrop);
                                      setShowProductDrop(false);
                                      setShowProductBottomList(true);
                                      setTypeField("asc");
                                    }}
                                  >
                                    <div className="order-count-title">
                                      {items.productPartName}
                                    </div>
                                    {isBuildingBlock && (
                                      <div className="title-hover">
                                        <div className="items-desc-column4">
                                          <div className="desc-image-wrp4 desc-image4 ">
                                            {items?.cover ? (
                                              <>
                                                <div
                                                  className={`product-list-image-default4 ${
                                                    items?.image?.length === 0
                                                      ? "hover-hide4"
                                                      : ""
                                                  }`}
                                                >
                                                  <img
                                                    src={items?.cover}
                                                    alt=""
                                                    className="cover-image4"
                                                  />
                                                  {items?.image &&
                                                    items?.image?.length >
                                                      0 && (
                                                      <div className="image-row4">
                                                        {items?.image
                                                          .slice(0, 3)
                                                          .map((val, index) => (
                                                            <img
                                                              key={index}
                                                              src={val.image}
                                                              alt={`Images ${
                                                                index + 1
                                                              }`}
                                                            />
                                                          ))}
                                                      </div>
                                                    )}
                                                </div>
                                                {items?.image &&
                                                  items?.image?.length > 0 && (
                                                    <span className="desc-image-plus4">
                                                      <Image
                                                        height={10}
                                                        width={10}
                                                        src={plusBorderWhite}
                                                      />
                                                    </span>
                                                  )}
                                              </>
                                            ) : (
                                              <div className="product-list-default4">
                                                <img
                                                  src={Package}
                                                  alt=""
                                                  className="default-img4"
                                                />
                                                <div className="product-image-title4 d-none">
                                                  Picture
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                    <div className="count-col ps-3">
                                      <div className="stock-order-col">
                                        {/* Stock */}
                                        {t("Stock")}
                                      </div>
                                    </div>

                                    <div className="stock-items">
                                      <div className="d-flex align-items-center gap-4 justify-content-center">
                                        <div className="d-flex flex-column align-items-center justify-content-center gap-1">
                                          <div
                                            style={{
                                              backgroundColor: `${items.color}`,
                                            }}
                                            className="color-code"
                                          ></div>
                                        </div>

                                        <div className="info-items">
                                          {items.instock}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                    {(screenSize === "xs" || isOrderPicking) && (
                      <div style={{ marginTop: "20px" }}>
                        <div
                          style={{
                            display: "flex",
                            borderBottom: "1px dotted #A5A5A5",
                            padding: "5px 0",
                          }}
                        >
                          <p
                            style={{
                              width: "30%",
                              color: "#707070",
                              marginBottom: "0",
                            }}
                          >
                            Project ID
                          </p>
                          <p
                            style={{
                              width: "70%",
                              color: "#707070",
                              marginBottom: "0",
                            }}
                          >
                            Project
                          </p>
                        </div>

                        {/* mobile */}
                        {projectTableData
                          ?.filter(
                            (x) =>
                              x.projectname
                                ?.toLowerCase()
                                .includes(searchItems.toLowerCase()) ||
                              x.projectcode
                                ?.toLowerCase()
                                .includes(searchItems.toLowerCase()),
                          )
                          .map((item) => {
                            return (
                              <div
                                onClick={() => {
                                  history.push(
                                    "/order-picking-PO-items-mobile",
                                    {
                                      projectId: item.projectid,
                                      projectName: item.projectname,
                                    },
                                  );
                                  handleSelectedProduct(item);
                                  setTypeField("asc");
                                }}
                                style={{
                                  display: "flex",
                                  gap: "20px",
                                  padding: "5px 0",
                                  borderBottom: "1px dotted #A5A5A5",
                                  alignItems: "center",
                                }}
                              >
                                <p
                                  style={{
                                    width: "30%",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    display: "block",
                                    marginBottom: "0",
                                  }}
                                >
                                  {item?.projectcode}
                                </p>
                                <p
                                  style={{
                                    width: "70%",
                                    wordWrap: "break-word",
                                    overflow: "hidden",
                                    marginBottom: "0",
                                    color: "#323232",
                                  }}
                                >
                                  {item?.projectname}
                                </p>
                                <img
                                  alt=""
                                  src={Downarrow}
                                  style={{
                                    opacity: "60%",
                                    width: "18px",
                                    height: "12px",
                                    transform: "rotate(-90deg)",
                                    cursor: "pointer",
                                    color: "#333333",
                                  }}
                                />
                              </div>
                            );
                          })}
                      </div>
                    )}
                  </div>

                  {screenSize !== "xs" && !isOrderPicking && (
                    <div className="product-list-Field w-100">
                      <div className="d-flex flex-wrap gap-3 items-row">
                        <div className="order-table-th col-md-3">
                          <h3 className="order-table-heading">
                            {/* Item ID */}
                            {t("Item ID")}
                          </h3>
                          <div className="order-table-td">
                            <div className="order-table-output">
                              {productBottomTableData?.productPartCode}
                            </div>
                          </div>
                        </div>
                        <div className="order-table-th col-md-3 d-none">
                          <h3 className="order-table-heading">
                            {/* Supplier Code */}
                            {t("Supplier Code")}
                          </h3>
                          <div className="order-table-td">
                            <div className="order-table-output">
                              {productBottomTableData?.productPartCode}
                            </div>
                          </div>
                        </div>
                        <div className="order-table-th col-md-2">
                          <h3 className="order-table-heading">
                            Kg
                            {/* {FetchTranslationList[19]?.translation} */}
                          </h3>
                          <div className="order-table-td">
                            <div className="order-table-output">
                              {productBottomTableData?.kg}
                            </div>
                          </div>
                        </div>
                        <div className="order-table-th col-md-2">
                          <h3 className="order-table-heading">
                            {/* In Stock */}
                            {t("In Stock")}
                          </h3>
                          <div className="order-table-td">
                            <div className="order-table-output">
                              {productBottomTableData?.instock}
                            </div>
                          </div>
                        </div>

                        <div className="col-2 d-none"></div>

                        <div className="order-table-th col-md-3 ms-1">
                          <h3 className="order-table-heading">
                            {/* Qty to Pick */}
                            {t("Qty to Pick")}
                          </h3>
                          <div className="d-flex justify-content-center">
                            <div
                              className="order-table-output pt-0"
                              style={{
                                border:
                                  productBottomTableData?.ispicked === 1 &&
                                  "2px solid green",
                              }}
                            >
                              <input
                                disabled={
                                  productBottomTableData?.ispicked === 1
                                }
                                value={
                                  productBottomTableData?.newQtyToPick ??
                                  productBottomTableData?.qtyToPick ??
                                  0
                                }
                                min="0"
                                type="number"
                                onChange={(e) => handleInputChange(e)}
                                style={{
                                  border: "none",
                                  height: "inherit",
                                  width: "100%",
                                  textAlign: "center",
                                }}
                              />
                            </div>
                          </div>

                          {productBottomTableData?.ispicked === 1 ? (
                            <span style={{ color: "green" }}>
                              Already picked
                            </span>
                          ) : productBottomTableData?.newQtyToPick >
                            productBottomTableData?.instock ? (
                            <span style={{ color: "red" }}>
                              Qty can't exceed stock
                            </span>
                          ) : productBottomTableData?.newQtyToPick >
                            productBottomTableData?.qtyToPick ? (
                            <span style={{ color: "red" }}>
                              You cannot pick item above the qtyToPick
                            </span>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderPicking;
